<!--
  @Description: 
  @Author: wang.y 
  @Date: 2022-05-31 
-->
<template>
  <div class="login">
    <div class="login-container">
      <div class="header">
        <img :src="$store.state.static_img_url+'pic/logo.png'">
      </div>
      <div class="content">
        <p class="tip">手机验证码登录</p>
        <Form ref="code_logoin_form" :model="code_logoin_form" :rules="ruleValidate">
          <FormItem prop="mobile">
            <Input v-model="code_logoin_form.mobile" placeholder="请输入手机号" autocomplete="off"></Input>
          </FormItem>
          <FormItem v-if="nc_status">
            <div class="nc-cnt">
              <div id="nc"></div>
            </div>
          </FormItem>
          <FormItem prop="code">
            <Input v-model="code_logoin_form.code" placeholder="请输入验证码" autocomplete="off"></Input>
            <Captcha
              ref="captcha"
              scene="vbdata_loginon"
              :mobile="code_logoin_form.mobile"
            ></Captcha>
          </FormItem>
        </Form>
        <Button @click="loginOnPhone" :loading="login_button_loading">登录</Button>
      </div>
    </div>
  </div>
</template>
<script>
import { loginOnPhone, liveurl } from '@/service'
import Captcha from '@/components/Captcha'
export default {
  components: {
    Captcha
  },
  created() {},
  mounted() {},
  data() {
    return {
      form_type: 'code_logoin_form',
      ruleValidate: {
        mobile: [
          { required: true, message: '请输入您的联系电话', trigger: 'blur' },
          {
            type: 'number',
            message: '手机号格式不正确',
            trigger: 'blur',
            transform(value) {
              let reg = /^1[3456789]\d{9}$/
              if (!reg.test(value)) {
                return false
              } else {
                return Number(value)
              }
            },
          },
        ],
        code: [{ required: true, message: '请填写正确的验证码', trigger: 'blur' }],
        pic_code: [{ required: true, message: '请填写正确的图片验证码', trigger: 'blur' }],
      },
      code_logoin_form: {
        mobile: '',
        code: '',
        pic_code: '',
        login_type: '1',
        scene: 'vbdata_loginon',
      },
      login_button_loading: false,
    }
  },
  computed: {},
  methods: {
    loginOnPhone() {
      // 验证码登录和账号密码
      this.$refs[this.form_type].validate(async (valid) => {
        if (valid) {
          this.login_button_loading = true
          let res = await loginOnPhone(this[this.form_type], (error) => {
            this.$Message.error('请求失败！')
          })
          this.login_button_loading = false
          if (res.status == 'success') {
            this.logoSuccess(res)
          } else {
            this.$Message.error(res.message)
          }
        }
      })
    },
    async getliveurl(url, user_key) {
      let res = await liveurl(
        {
          loginType: 1,
          redirectUrl: url,
          userKey: user_key,
        },
        (error) => {
          this.$message.error('请求错误！')
        }
      )
      if (res.code == 0) {
        let tourl = res.data.loginUrl
        window.location.href = tourl
      } else {
        this.$message.error(res.msg)
      }
    },
    logoSuccess(res) {
      Cookies.set('user_key', res.user_key)
      Cookies.set('timestamp_left', moment().unix())
      Cookies.set('timestamp_right', moment().unix())

      this.$store.commit('updateUserKey', res.user_key)
      this.$store.commit('updateUser', res.user)
      this.$store.commit('setUUserId', res.user.id)
      
      if (this.$route.query.redirect_uri) {
        this.getliveurl(this.$route.query.redirect_uri, res.user_key)
      }
    },
  },
}
</script>
<style lang='stylus' scoped>
.login
  height 100vh
  min-height 400px
  min-width 400px
  display flex
  justify-content center
  align-items center
  .login-container
    width 380px
    padding 0
    box-shadow 0px 10px 30px 0px rgba(121, 133, 143, 0.1)
    .header
      padding 16px 20px
      border-bottom 1px solid #f5f5f5
      img
        height 32px
        display block
    .content
      padding 24px 28px 28px
    .tip
      font-size 16px
      color #333333
      line-height 1
    >>> .ivu-form
      margin-top 16px
      .ivu-form-item
        margin-bottom 20px
        .ivu-form-item-content
          .ivu-input
            background #F8F8FA
            border-color #F8F8FA
            border-radius 4px
            color #333
            height 40px
            font-size 14px
            padding 10px
            &::-webkit-input-placeholder
              color #999
            &:focus
              box-shadow none
              border-color rgba(250, 122, 80, 1)
          .code-btn
            position absolute
            z-index 2
            top 10px
            right 10px
          .forget-paw
            position absolute
            top 40px
            right 0
            font-size 14px
            color #999999
            cursor pointer
            &:hover
              color #FC9C7C
        &:last-of-type
          margin-bottom 0
        .ivu-form-item-error-tip
          position inherit
          color #F3494B
        &.ivu-form-item-error
          .ivu-input
            border-color #F3494B
    .ivu-btn
      width 100%
      height 40px
      background rgba(250, 122, 80, 1)
      border-radius 4px
      border-color rgba(250, 122, 80, 1)
      font-size 14px
      color #FFFFFF
      margin-top 20px
      &:focus
        box-shadow none
      &:hover
        background-color #FC9C7C
        border-color #FC9C7C
</style>